import { SITEMAP_REPORT } from '@components/Router/constants'
import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { generatePath, useParams } from 'react-router-dom'

import Octopus from '../../assets/images/error.svg?react'
import css from './styles.module.css'

// A report project opened at the editor URL. It has no canvas to render, so
// the editor says so and offers the screen that can show it.
// The pages behind these buttons load in full, as the links here used to
const openPage = (url: string) => {
  window.location.assign(url)
}

export const NoSitemap: React.FC = () => {
  const { uuid = null } = useParams<{ uuid: string }>()

  return (
    <div className={css.container}>
      <a className={css.logo} href="/">
        <Octopus />
      </a>
      <div className={css.content}>
        <div className={css.heading}>This project has no sitemap</div>
        <div className={css.body}>
          It is a website report, not a sitemap, so
          <br />
          there is nothing to open on the canvas.
        </div>
        <div className={css.actions}>
          {uuid && (
            <Button
              size="medium"
              label="Open the report"
              onClick={() => openPage(generatePath(SITEMAP_REPORT, { uuid }))}
            />
          )}
          <Button
            priority="ghost"
            size="medium"
            label="Back to projects"
            onClick={() => openPage('/dashboard')}
          />
        </div>
      </div>
    </div>
  )
}
